<template>
	<div class="all-nav">
		<div class="cont">
			<el-popover placement="bottom" width="371" trigger="hover">
				<div class="code-cont">
					<div class="android-cont">
						<div id="idsAndroid"></div>
						<p class="load-text">安卓版下载</p>
					</div>
					<div class="android-cont">
						<div id="idsIos"></div>
						<p class="load-text">IOS版下载</p>
					</div>
				</div>
				<div slot="reference" class="cont-left">
					客户端下载
				</div>
			</el-popover>
			<div class="cont-right" v-if="!isLogin">
				<img class="coupon-img" :src="$store.state.basePicUrl + 'image/base/user.png'">
				<span class="reg-span" @click="toReg">注册</span>
				<p class="line"></p>
				<span class="reg-span" @click="toLogin">登录</span>
			</div>
			<div class="cont-right" v-if="isLogin">
				<!-- <div class="right-item" @click="toPerson('myCoupon')">
					<img class="coupon-img" :src="$store.state.basePicUrl + 'image/base/coupon.png'">
					<span class="coupon-span">优惠券</span>
				</div>
				<div class="right-item">
					<img class="coupon-img" :src="$store.state.basePicUrl + 'image/base/service.png'">
					<span class="coupon-span">客服</span>
				</div>
				<div class="right-item" @click="toPerson('shoppingCart')">
					<img class="coupon-img" :src="$store.state.basePicUrl + 'image/base/cart.png'">
					<span class="coupon-span">购物车</span>
				</div> -->
				<div class="right-item" @click="toPerson('messageCenter')">
					<img class="coupon-img" :src="$store.state.basePicUrl + 'image/base/message.png'">
					<span class="coupon-span">消息</span>
				</div>
				<div class="login-li">
					<el-popover placement="bottom" width="100" trigger="hover">
						<div class="logout-item">
							<p @click="toPerson('myCourse')"><img class="coupon-img"
									:src="$store.state.basePicUrl + 'image/base/user.png'">个人中心</p>
							<p @click="logOut">退出</p>
						</div>
						<div slot="reference" class="login-li">
							<img class="tx-img" :src="res.pic" />
							<!-- {{ getEncryptPhone(res.name) }} -->
						</div>
					</el-popover>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getToken,
		removeToken
	} from "@/utils/auth";
	import {
		logout,
		getUserInfo,
		getWebConfig
	} from "@/api/home.js"
	import sha256_digests from "js-sha256";
	import {
		mapState,
		mapMutations
	} from "vuex"
	import QRCode from "qrcodejs2";

	export default {
		watch: {
			"$store.state.isChange"(newval, oldval) {
				if (getToken()) {
					this.isLogin = true;
					this.getInfo();
				}
			},
			"$store.state.ifLOGIN"(newval, oldval) {
				if (newval && getToken()) {
					this.isLogin = true;
					this.getInfo();
				}
			},
			immediate: true,
			deep: true
		},
		data() {
			return {
				isLogin: false,
				res: {}
			}
		},
		mounted() {
			if (getToken()) {
				this.isLogin = true;
				this.getInfo();
			} else {
				this.isLogin = false;
			}
			
			this.getConfig();
		},
		methods: {
			//生成二维码
			getCodeAndroid(code) {
				if (erweima) {
					erweima.clear();
				}
				document.getElementById("idsAndroid").innerHTML = "";
				var erweima = new QRCode("idsAndroid", {
					width: 145, //图像宽度
					height: 145, //图像高度
					colorDark: "#000000", //前景色
					colorLight: "#ffffff", //背景色
					typeNumber: 4,
					correctLevel: QRCode.CorrectLevel
						.H //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
				});
				erweima.makeCode(code); //生成另一个新的二维码
			},
			getCodeIos(code) {
				if (erweima) {
					erweima.clear();
				}
				document.getElementById("idsIos").innerHTML = "";
				var erweima = new QRCode("idsIos", {
					width: 145, //图像宽度
					height: 145, //图像高度
					colorDark: "#000000", //前景色
					colorLight: "#ffffff", //背景色
					typeNumber: 4,
					correctLevel: QRCode.CorrectLevel
						.H //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
				});
				erweima.makeCode(code); //生成另一个新的二维码
			},
			getConfig() {
				getWebConfig({}).then(data => {
					data.result.version.forEach(item => {
						if (item.type == 1) {
							// this.androidCode = item.downloadUrl;
							this.getCodeAndroid(item.downloadUrl);
						} else {
							// this.iosCode = item.downloadUrl;
							this.getCodeIos(item.downloadUrl);
						}
					})
				})
			},
			toPerson(type) {
				this.$router.push({
					path: "/personal",
					query: {
						selTab: type
					}
				})
			},
			toReg() {
				this.$router.push({
					path: "/reg"
				});
			},
			toLogin() {
				this.$store.state.backUrl = window.location.href;
				this.$router.push({
					path: "/login"
				});
			},
			logOut() {
				this.$confirm("确认退出登录吗？?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning"
					})
					.then(() => {
						console.log("退出登录")
						logout({}).then(data => {
							if (data.code == 0) {
								this.$store.state.ifLOGIN = false;
								removeToken();
								this.$message.success("退出成功");
								this.isLogin = false;
								this.$store.state.backUrl = window.location.href;
								this.$router.push({
									path: "/login"
								});
							}
						});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消退出"
						});
					});
			},
			getInfo() {
				getUserInfo({}).then(data => {
					this.res = data.result.userVo;
					this.$store.state.userInfo = data.result.userVo;
				})
			}
		}
	}
</script>

<style scoped>
	.code-cont {
		width: 371px;
		height: 201px;
		display: flex;
	}
	
	.android-cont {
		width: 185px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	
	.load-text {
		margin-top: 12px;
	}
	.all-nav {
		width: 100%;
		height: 32px;
		background: #F3F4F7;
	}

	.cont {
		width: 1200px;
		margin: 0 auto;
		height: 32px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.cont-left {
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #0F1D34;
		cursor: pointer;
	}

	.cont-right {
		display: flex;
		align-items: center;
	}

	.reg-span {
		cursor: pointer;
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #0F1D34;
	}

	.line {
		width: 1px;
		height: 14px;
		background: #CDCFD6;
		margin: 0 6px;
	}

	.right-item {
		display: flex;
		align-items: center;
		margin-right: 32px;
		cursor: pointer;
	}

	.coupon-img {
		width: 16px;
		height: 16px;
		margin-right: 4px;
	}

	.coupon-span {
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #0F1D34;
	}

	.tx-img {
		width: 24px;
		height: 24px;
		border-radius: 50%;
	}

	.logout-item {
		cursor: pointer;
		text-align: center;
		line-height: 40px;
	}
</style>



// WEBPACK FOOTER //
// src/components/base/topNav.vue